export default __webpack_public_path__ + "static/media/2-formacao.6879b797.svg";